import { array_from_query, number_from_query, str_from_query } from "@/api";
import { axios_instance } from "@/api/api";
import { router } from "@/router/router";
import { defineStore } from "pinia";
import { computed, onMounted, ref, watch } from "vue";
import { toast } from "vue3-toastify";
import type { open_port } from ".";

export const use_open_port = defineStore("open_port", () => {
  const open_port = ref<open_port[]>([]);
  const loading = ref<{
    get_open_ports: boolean;
  }>({
    get_open_ports: false,
  });
  const total_filter = ref<number>(0);
  const total_pages = computed(() =>
    Math.max(1, total_filter.value / number_from_query("size", 24)),
  );

  const get_open_ports = () => {
    const action_id = router.currentRoute.value.params.action_id;
    if (!action_id) return;

    const data = JSON.stringify({
      action_id: router.currentRoute.value.params.action_id,
      page: number_from_query("page", 1),
      size: number_from_query("size", 24),
      keyword: str_from_query("keyword"),
      protocol: array_from_query("protocol", String),
    });

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "/api/v1/view/open-port/pagination",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios_instance
      .request<{ data: open_port[] | null; total_filter: number }>(config)
      .then((response) => {
        if (response.data) {
          open_port.value = response.data.data ?? [];
          total_filter.value = response.data.total_filter;
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  onMounted(() => {
    get_open_ports();
  });

  watch(
    () => [router.currentRoute.value.query],
    () => {
      if (router.currentRoute.value.name !== "ClientOpenedPortScanDetail")
        return;
      get_open_ports();
    },
  );

  return {
    open_port,
    loading,
    total_filter,
    total_pages,
    get_open_ports,
  };
});
